import { c as _c } from "react/compiler-runtime";
import { usePathname } from '@/i18n/navigation';
import { useParams } from 'next/navigation';
export const useIsPublicProfileVideoPage = () => {
  const $ = _c(3);
  const params = useParams();
  const pathname = usePathname();
  let t0;
  if ($[0] !== params.identifier || $[1] !== pathname) {
    t0 = !!params.identifier && pathname.includes("/watch/");
    $[0] = params.identifier;
    $[1] = pathname;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};